<template>
  <a
    href="javascript:void(0);"
    class="card hover-elevate-up"
    @click="$emit('select', id)"
  >
    <div class="card d-flex flex-column h-100">
      <div class="image-mask">
        <img
          class="image-bg"
          src="/media/img/questionnaire_persona/persona_bg.png"
        />
        <div class="image-wrapper">
          <img class="card-image" :src="imageSrc" alt="card image" />
        </div>
      </div>
      <div class="py-4 px-6">
        <h3
          class="text-card-title parent-hover-primary mb-0 fs-4 fs-md-3 fw-bolder"
        >
          {{ title }}
        </h3>
        <p
          class="text-card-description mb-0 text-gray-700 parent-hover-primary fs-7 fs-md-6"
        >
          {{ description }}
        </p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "BasicCard",
  props: {
    title: {
      default: "",
      type: String,
    },
    description: {
      default: "",
      type: String,
    },
    imageSrc: {
      default: "",
      type: String,
    },
    id: {
      required: true,
      type: [String, Number],
    },
    mobile: {
      required: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0px 8px 20px 0px rgba(21, 37, 72, 0.05);
  border-radius: 8px;
  user-select: none;

  .image-mask {
    width: 100%;
    padding-bottom: 72%;
    height: 0;
    position: relative;
    overflow: visible;

    .image-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-position: top;
      object-fit: cover;
      z-index: 1;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .card-image {
      z-index: 2;
      width: 100%;
      object-fit: cover;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  &:hover {
    box-shadow: 0px 10px 40px rgba(21, 37, 72, 0.1);

    .text-card-title {
      color: #0098a5;
    }

    scale: 1.05;
    transition: all 100ms ease-out;
  }
}

.text-card-title {
  color: var(--color-text-primary);
  line-height: 2.1rem;
}

.text-card-description {
  color: var(--color-text-description);
  line-height: 1.6rem;
}

@media (max-width: 575px) {
  .text-card-title {
    line-height: 1.8rem;
  }

  .text-card-description {
    line-height: 1.2rem;
  }
}
</style>
